import React from "react";

// Custom bespoke button: transparent w/ neon border. Two variants: pink & cyan.
const NeonButton = React.forwardRef(
  ({ children, variant = "pink", className = "", as: Tag = "button", ...props }, ref) => {
    const palette =
      variant === "cyan"
        ? {
            border: "border-[#00F0FF]",
            text: "text-[#00F0FF]",
            shadow: "hover:shadow-[0_0_28px_rgba(0,240,255,0.65)]",
            bgHover: "hover:bg-[#00F0FF]",
            hoverText: "hover:text-[#0A0510]",
          }
        : {
            border: "border-[#FF007A]",
            text: "text-[#FF007A]",
            shadow: "hover:shadow-[0_0_28px_rgba(255,0,122,0.7)]",
            bgHover: "hover:bg-[#FF007A]",
            hoverText: "hover:text-[#0A0510]",
          };
    return (
      <Tag
        ref={ref}
        className={`group relative inline-flex items-center justify-center gap-3 border ${palette.border} ${palette.text} bg-transparent px-7 py-3.5 font-mono text-[11px] uppercase tracking-[0.32em] transition-all duration-300 ${palette.shadow} ${palette.bgHover} ${palette.hoverText} ${className}`}
        {...props}
      >
        <span className="relative z-10">{children}</span>
        <span aria-hidden className="relative z-10 inline-block h-1.5 w-1.5 rounded-full bg-current shadow-[0_0_8px_currentColor] transition-transform group-hover:translate-x-1" />
      </Tag>
    );
  }
);
NeonButton.displayName = "NeonButton";

export default NeonButton;
